import { Flex } from '@servicetitan/anvil2';
import { DateTimeUtils } from '@servicetitan/datetime-utils';
import { BodyText, Icon } from '@servicetitan/design-system';
import { useDependencies } from '@servicetitan/react-ioc';
import { observer } from 'mobx-react';
import { FC } from 'react';
import { CoveredJob, CoveredJobStatus } from '../../../api/portal-dashboard.api';

interface CoveredJobsFooterProps {
    coveredJobs?: CoveredJob[];
}

export const CoveredJobsFooter: FC<CoveredJobsFooterProps> = observer(({ coveredJobs }) => {
    const [dateTimeUtils] = useDependencies(DateTimeUtils);

    if (!coveredJobs || coveredJobs?.length === 0) {
        return null;
    }

    const orderedJobs = coveredJobs
        ?.slice()
        .sort((a, b) => a.startDate.getTime() - b.startDate.getTime());

    const jobToDisplay = orderedJobs && orderedJobs.length > 0 ? orderedJobs[0] : undefined;

    if (!jobToDisplay?.startDate || !jobToDisplay.endDate) {
        return null;
    }

    return (
        <Flex direction="column">
            <BodyText subdued size="small">
                <Icon name="timer" size={16} className="m-r-half m-b-half" /> First Job:
                {` ${dateTimeUtils.formatShortMonth(jobToDisplay.startDate)} ${jobToDisplay.startDate.getDate()} `}
                -
                {` ${dateTimeUtils.formatShortMonth(jobToDisplay.endDate)} ${jobToDisplay.endDate.getDate()} `}
                •{' ' + CoveredJobStatus[jobToDisplay.status]}
            </BodyText>
        </Flex>
    );
});
